import gql from 'graphql-tag';

export const UPDATE_PAGE_MUTATION = gql`
  mutation UpdatePage($id: ID!, $input: UpdatePageInput!) {
    updatePage(id: $id, input: $input) {
      page {
        id
      }
    }
  }
`;
